import React from 'react';
import { IconBase } from '../Base';
export const IconPlay = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { strokeWidth: "1.5", style: { stroke: 'var(--icon-color)', fill: 'var(--icon-fill, none)' }, d: "M6 14.7048V5.29515C6 4.51164 6.86016 4.03248 7.52636 4.44489L15.1265 9.14973C15.758 9.54068 15.758 10.4593 15.1265 10.8503L7.52635 15.5551C6.86016 15.9675 6 15.4884 6 14.7048Z" })));
};
//# sourceMappingURL=Play.js.map